<script lang="ts">
    import SortableTable from "$lib/components/SortableTable.svelte";
    import {listProjects} from "$lib/calls/project";
    import colors from "tailwindcss/colors";
    import {DoubleBounce} from "svelte-loading-spinners";
    import Pagination from "$lib/components/Pagination.svelte";
    import DateDisplay from "$lib/components/ui/DateDisplay.svelte";
    import ProjectStatus from "$lib/components/ProjectStatus.svelte";
    import OpenButton from "$lib/components/ui/OpenButton.svelte";
    import {onMount} from "svelte";
    import {page} from "$app/stores";
    import {afterNavigate, goto} from "$app/navigation";
    import {fade} from 'svelte/transition';
    import {projectsHeader} from "$lib/utils/tableHeaders/projects";
    import Toggle from "$lib/components/ui/Toggle.svelte";
    import PageLayout from "$lib/components/PageLayout.svelte";
    import SearchFilter from "$lib/components/SearchFilter.svelte";
    import {Button, Checkbox, Dropdown, Spinner} from "flowbite-svelte";
    import {ChevronDownOutline, GridOutline, PlusOutline} from "flowbite-svelte-icons";
    import ProjectCards from "$lib/partials/ProjectCards.svelte";
    // TODO: consolidate & clean up like employees!

    export let data;

    let loading = true;

    let header = projectsHeader;

    let originalHeader = [...header]

    const headerColumnChange = (property: string, display: boolean) => {
        if (display && !header.find(x => x.property === property)) {
            let ind = originalHeader.findIndex(x => x.property === property)
            header.splice(ind, 0, originalHeader[ind])
            header = [...header]
        } else {
            header = header.filter(x => x.property !== property)
        }

    }

    let pagination = [];

    let listMode = true;

    const setFilter = async (filterName: string, filterValue: string) => {
        if (filterValue === '') {
            $page.url.searchParams.delete(filterName)
            delete data[`filter[${filterName}]`]
        } else {
            $page.url.searchParams.set(`filter[${filterName}]`, filterValue)
            data[`filter[${filterName}]`] = filterValue
        }

        await goto('/projects?' + $page.url.searchParams.toString())
    }

    let setSearch = async value => {
        $page.url.searchParams.set(`search`, value)
        await goto('/projects?' + $page.url.searchParams.toString())
    }


    let handleSort = async ev => {
        data.sort = ev.detail.property;
        data.order = ev.detail.order < 0 ? 'desc' : 'asc';
        data.page = 1;
        $page.url.searchParams.set('sort', data.sort)
        $page.url.searchParams.set('order', data.order)
        $page.url.searchParams.set('pageSize', data.pageSize)
        $page.url.searchParams.set('page', data.page)
        await goto('/projects?' + $page.url.searchParams.toString())

    }


    afterNavigate(async (ev) => {
        pagination = await listProjects(data);
    })

    onMount(async () => {
        pagination = await listProjects(data);

        loading = false;
    })


</script>

<section>
    <SearchFilter on:enter={ev => setSearch(ev.detail)} on:clear={ev => setSearch('')}>
        <svelte:fragment slot="cta">
            <div>
                <Button>Status
                    <ChevronDownOutline class="w-3 h-3 ml-2"/>
                </Button>
                <Dropdown class="w-52 p-3 space-y-3 text-sm">
                    <li>
                        <button on:click={() => setFilter('status', '')}
                                class="text-gray-700 block px-4 py-2 text-sm hover:text-neutral-800" role="menuitem"
                                tabindex="-1">
                            Alle
                        </button>
                    </li>
                    <li>
                        <button on:click={() => setFilter('status', 'requested')}
                                class="text-gray-700 block px-4 py-2 text-sm hover:text-neutral-800" role="menuitem"
                                tabindex="-1">
                            Anfrage
                        </button>
                    </li>
                    <li>
                        <button on:click={() => setFilter('status', 'confirmed')}
                                class="text-gray-700 block px-4 py-2 text-sm hover:text-neutral-800" role="menuitem"
                                tabindex="-1">
                            Auftrag
                        </button>
                    </li>
                    <li>
                        <button on:click={() => setFilter('status', 'finished')}
                                class="text-gray-700 block px-4 py-2 text-sm hover:text-neutral-800" role="menuitem"
                                tabindex="-1">
                            Stunden gebucht
                        </button>
                    </li>
                    <li>
                        <button on:click={() => setFilter('status', 'billing')}
                                class="text-gray-700 block px-4 py-2 text-sm hover:text-neutral-800" role="menuitem"
                                tabindex="-1">
                            Rechnung geschrieben
                        </button>
                    </li>
                    <li>
                        <button on:click={() => setFilter('status', 'canceled')}
                                class="text-gray-700 block px-4 py-2 text-sm hover:text-neutral-800" role="menuitem"
                                tabindex="-1">
                            Storniert
                        </button>
                    </li>

                </Dropdown>

            </div>
            <Button href="/create/project">
                <PlusOutline class="w-3 h-3 mr-1"/>
                Projekt
            </Button>
            <Button color="alternative" on:click={() => listMode =! listMode}>
                <GridOutline class="w-3 h-3 mr-2"/>
                Ansicht
            </Button>
            {#if listMode}
                <div>
                    <Button color="alternative">Spalten
                        <ChevronDownOutline class="w-3 h-3 ml-2"/>
                    </Button>
                    <Dropdown class="w-44 p-3 space-y-3 text-sm">
                        <li class="p-2 flex gap-3 items-center">
                            <Toggle label="Kundennummer" value={header.find(x => x.property === 'customer.registry')}
                                    on:change={(ev) => headerColumnChange('customer.registry', ev.detail)}/>
                        </li>
                        <li class="p-2 flex gap-3 items-center">
                            <Toggle label="Kunde" value={header.find(x => x.property === 'customerId')}
                                    on:change={(ev) => headerColumnChange('customerId', ev.detail)}/>
                        </li>
                        <li class="p-2 flex gap-3 items-center">
                            <Toggle label="Status" value={header.find(x => x.property === 'status')}
                                    on:change={(ev) => headerColumnChange('status', ev.detail)}/>
                        </li>
                    </Dropdown>
                </div>
            {/if}
        </svelte:fragment>
    </SearchFilter>
    {#if loading}
        <div class="text-center my-5">
            <Spinner/>
        </div>
    {:else if listMode}


        <SortableTable rowClick={row => goto('/project/'+row.uuid)} {header} data={pagination.collection}
                       on:sort={handleSort}/>
        <div class="mt-5">
            <Pagination {pagination}/>
        </div>
    {:else}
        <ProjectCards projects={pagination.collection}/>
        <div class="mt-5">
            <Pagination {pagination}/>
        </div>
    {/if}
</section>
